// What? Utility for checking if dev-only features should be enabled
// Why? To conditionally show debug/test features only in development environments
// How? Checks environment variables to determine if dev features should be enabled
import {
  getRuntimeConfig,
  isRuntimeFlagEnabled,
} from "../config/runtimeConfig";

/**
 * Check if dev-only features should be enabled
 *
 * Dev features are enabled when:
 * - Runtime enableDevFeatures is set to 'true'
 * - OR NODE_ENV is 'development' (automatically set by npm start in dev mode)
 *
 * @returns true if dev features should be enabled, false otherwise
 */
export const isDevFeaturesEnabled = (): boolean => {
  // Check explicit flag first
  if (isRuntimeFlagEnabled(getRuntimeConfig().enableDevFeatures)) {
    return true;
  }

  // Fall back to NODE_ENV check (automatically set by npm start in dev mode)
  if (process.env.NODE_ENV === "development") {
    return true;
  }

  return false;
};
